import React, { useState, useEffect, useRef } from "react";
import { render } from "react-dom";
import { useParams, useNavigate } from "react-router-dom";
import { getLoggedInUser } from "../helpers";
import { useLocation, Link } from "react-router-dom";
import { Col, Row, Modal, ModalHeader, ModalBody } from "reactstrap";
import { connect } from "react-redux";
import { betSlipService } from "../redux/betslip/services";
import Loader from "../components/Loader/Loader";
import "react-datepicker/dist/react-datepicker.css";
import defaultImage from "../assets/images/images.png";
import { AiOutlineInfoCircle } from "react-icons/ai";
import { CiUser } from "react-icons/ci";
import { IoIosArrowDown } from "react-icons/io";

import Demo1 from "../components/cashwallet";
import Demo2 from "../components/DailyLimit";
import Demo3 from "../components/WageringLimit";
import Demo4 from "../components/SelfExclusion";
import Demo5 from "../components/ChangePassword";
import Demo6 from "../components/WithdrawList";
import Demo7 from "../components/KycDocList";
import Demo8 from "../pages/EditAccounts";
import Demo9 from "../components/NonCashWallet";
import Demo10 from "../components/UserprofileGameplay";
import Demo11 from "../components/self";
import { useTranslation } from "react-i18next";

import casinoDies from "../../src/assets/images/account/casino-dies.jpg";

const UserProfile = (props) => {
  const uploadRef = useRef(null);
  const location = useLocation();
  const { t } = useTranslation();
  const [user, setUser] = useState(getLoggedInUser());
  const [startDate, setStartDate] = useState(new Date());
  const [isLoading, setIsLoading] = useState(false);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [profileImg, setProfileImg] = useState("");
  const [walletList, setWalletList] = useState([]);
  const [userList, setUserList] = useState([]);
  const [file, setFile] = useState("");
  const [resMessage, setResMessage] = useState("");
  const [visible, setVisible] = useState(false);
  const [name, setName] = useState("");
  const [activeTab, setActiveTab] = useState("profile");
  const [showDropdown2, setShowDropdown2] = useState(false);

  const dropdownRef = useRef(null);

  const [dropdownOpen, setDropdownOpen] = useState({
    transactions: false,
    responsibleGaming: false,
  });
  const [showHideDemo, setShowHideDemo] = useState({
    demo1: false,
    demo2: false,
    demo3: false,
    demo4: false,
    demo5: false,
    demo6: false,
    demo7: false,
    demo8: false,
    demo9: false,
    demo10: false,
    demo11: false,
    demo12: false,
  });
  const [slidebar, setSlidebar] = useState(false);
  const [isModalOpenOne, setIsModalOpenOne] = useState(false);
  const [showSubMenu, setShowSubMenu] = useState(false);
  const [showSubMenu1, setShowSubMenu1] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [showDropdown1, setShowDropdown1] = useState(false);
  const [setPasswordResetSuccessful, setSetPasswordResetSuccessful] =
    useState(false);
  const [setPasswordResetfail, setSetPasswordResetfail] = useState(false);
  const { tab } = useParams();
  const navigate = useNavigate();

  const [currentPage, setCurrentPage] = useState(tab || "profile");
  const handleTabClick = (tabName) => {
    setCurrentPage(tabName);
    navigate(`/user-profile/${tabName}`);
    localStorage.setItem("currentPage", tabName);
  };

  useEffect(() => {
    if (tab) setCurrentPage(tab);
  }, [tab]);

  // const [currentPage, setCurrentPage] = useState(
  //   localStorage.getItem("currentPage") || "demo8"
  // );
  // const [setPasswordResetSuccessful, setSetPasswordResetSuccessful] =
  //   useState(false);
  // const [setPasswordResetfail, setSetPasswordResetfail] = useState(false);

  // const queryString = location.search;
  // const params = new URLSearchParams(queryString);
  // const param1 = params.get("set");

  // useEffect(() => {
  //   if (
  //     param1 &&
  //     [
  //       "demo1",
  //       "demo2",
  //       "demo3",
  //       "demo4",
  //       "demo5",
  //       "demo6",
  //       "demo7",
  //       "demo8",
  //       "demo9",
  //       "demo10",
  //       "demo11",
  //       "demo12",
  //     ].includes(param1)
  //   ) {
  //     setCurrentPage(param1);
  //   } else {
  //     setCurrentPage("demo8"); // Default to profile if no valid param
  //   }
  //   loadRecordsTables();
  //   const d = localStorage.getItem("currentPage");
  //   setCurrentPage(d ? d : "demo8");
  // }, [location.search]);

  // useEffect(() => {
  //   localStorage.setItem("currentPage", currentPage);
  // }, [currentPage]);

  // const hideComponent = (name) => {
  //   setCurrentPage(name);
  //   localStorage.setItem("currentPage", name);

  //   setShowHideDemo((prev) => {
  //     const updated = {
  //       demo1: name === "demo1",
  //       demo2: name === "demo2",
  //       demo3: name === "demo3",
  //       demo4: name === "demo4",
  //       demo5: name === "demo5",
  //       demo6: name === "demo6",
  //       demo7: name === "demo7",
  //       demo8: name === "demo8",
  //       demo9: name === "demo9",
  //       demo10: name === "demo10",
  //       demo11: name === "demo11",
  //       demo12: name==="demo12",
  //     };
  //     return updated;
  //   });
  // };

  const loadRecordsTables = () => {
    const reqData = {
      guid: user.guid,
    };
    setIsLoading(true);
    betSlipService.fatchUserDetails(reqData).then((res) => {
      let data = res.data;
      setIsLoading(false);
      setUserList(data);
    });
  };

  const onDismiss = () => {
    setVisible(false);
    setPasswordResetSuccessful(false);
    setPasswordResetfail(false);
  };

  const handleValidSubmit = (event, values) => {
    setIsLoading(true);
    let formData = new FormData();
    formData.append("guid", values.guid);
    formData.append("first_name", values.first_name);
    formData.append("last_name", values.last_name);
    formData.append("phone", values.phone);
    formData.append("email", values.email);
    formData.append("username", values.username);
    formData.append("password", values.password);
    formData.append("cnfm_password", values.cnfm_password);
    formData.append("profile_img", profileImg);
    const config = {
      headers: { "content-type": "multipart/form-data" },
    };
    // Do something with formData and config
  };

  const handleValidSubmitdate = (event, values) => {
    props.registerUser(values);
  };

  const onChangeFile = (event) => {
    event.preventDefault();
    let selectedFile = event.target.files[0];
    setProfileImg(selectedFile);

    let formData = new FormData();
    formData.append("guid", user.guid);
    formData.append("profile_img", selectedFile, selectedFile.name);
    const config = {
      headers: { "content-type": "multipart/form-data" },
    };

    betSlipService
      .updateUserProfile(formData, config)
      .then((res) => {
        setUserList((prev) => ({
          ...prev,
          profile_image: URL.createObjectURL(selectedFile),
        }));
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };
  const handleCallback = (childData) => {
    setSlidebar(childData);
  };

  const toggleModalOne = () => {
    setIsModalOpenOne((prev) => !prev);
  };

  const toggleSubMenu = () => {
    setShowSubMenu((prev) => !prev);
    setShowSubMenu1(false);
  };

  const toggleSubMenu1 = () => {
    setShowSubMenu1((prev) => !prev);
    setShowSubMenu(false);
  };

  const toggleOff = () => {
    setShowSubMenu(false);
    setShowSubMenu1(false);
  };
  // const handleTabClick = (tab) => {
  //   setActiveTab(tab);
  // };
  const toggleDropdown = (dropdown) => {
    setDropdownOpen((prevState) => ({
      ...prevState,
      [dropdown]: !prevState[dropdown],
    }));
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown1(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
      {isLoading && <Loader />}
      <div
        className="background"
        style={{
          position: "absolute",
          height: "100%",
          width: "100%",
          backgroundImage: `url(${casinoDies})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          zIndex: "-2",
          filter: "blur(99px)",
        }}
      ></div>
      <div className="account-pages">
        <section className="account-section overflow-hidden bg_img_login mt-5">
          <div className="profile-manage">
            <Row>
              {/* Sidebar */}
              <div
                className="user-toggler d-lg-none"
                onClick={() => setSlidebar(true)}
              >
                <i className="las la-sliders-h"></i>
              </div>

              <Col
                className="col-lg-3 mt-5"
                // className={`col-lg-3 mt-5 ${slidebar ? "d-none" : "d-block"} d-lg-block`}
              >
                <div
                  className={`dashboard-sidebar  ${slidebar ? "active" : "disactive"}`}
                >
                  {/* Close button on small devices */}
                  <div
                    className="close-dashboard d-lg-none"
                    onClick={() => setSlidebar(false)}
                  >
                    <i className="las la-times"></i>
                  </div>
                  {/* MODAL */}
                  <div className="withdraw-request-popup">
                    <div className="withdraw-request-popup1">
                      <Modal
                        className="withdraw-request-popup"
                        isOpen={isModalOpenOne}
                        toggle={toggleModalOne}
                      >
                        {/* <ModalHeader toggle={toggleModalOne}></ModalHeader> */}
                        <ModalBody>
                          <img
                            style={{ width: "100%" }}
                            src={userList?.profile_img || defaultImage}
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src = defaultImage;
                            }}
                            alt="User Profile"
                          />
                        </ModalBody>
                      </Modal>
                    </div>
                  </div>

                  {/* SIDEBAR CONTENT */}
                  <div className="first-div">
                    <ul className="user-box">
                      <li
                        className="user-item"
                        onClick={() => handleTabClick("profile")}
                      >
                        <Link
                          className={currentPage === "profile" ? "active" : ""}
                          onClick={() => setSlidebar(false)}
                        >
                          <i>
                            <img
                              src="/images/profilew.png"
                              alt="Logo"
                              className="hover-image"
                              style={{
                                width: "auto",
                                height: "16px",
                                objectFit: "contain",
                              }}
                            />
                          </i>{" "}
                          &nbsp;{t("userProfile.profileNav.profile")}
                        </Link>
                      </li>

                      <li className="nav-dropdown-item" ref={dropdownRef}>
                        <div
                          className={`nav-dropdown-toggle ${currentPage.startsWith("security") ? "active" : ""}`}
                          onClick={() => setShowDropdown2(!showDropdown2)}
                        >
                          <i>
                            <img
                              src="/images/withdraww.png"
                              alt="Logo"
                              className="nav-dropdown-icon"
                              style={{
                                width: "auto",
                                height: "16px",
                                objectFit: "contain",
                              }}
                            />
                          </i>
                          &nbsp; {t("userProfile.profileNav.transactions")}
                          <IoIosArrowDown />
                        </div>

                        {showDropdown2 && (
                          <ul className="nav-dropdown-menu">
                            <li
                              className="user-item"
                              onClick={() => handleTabClick("cashwallet")}
                            >
                              <Link
                                className={
                                  currentPage === "cashwallet" ? "active" : ""
                                }
                                onClick={() => {
                                  setSlidebar(false);
                                  setShowDropdown2(false);
                                }}
                              >
                                <i>
                                  <img
                                    src="/images/profilew.png"
                                    alt="Logo"
                                    className="hover-image"
                                    style={{
                                      width: "auto",
                                      height: "16px",
                                      objectFit: "contain",
                                    }}
                                  />
                                </i>{" "}
                                &nbsp;{t("userProfile.profileNav.cashWallet")}
                              </Link>
                            </li>
                            <li
                              className="user-item"
                              onClick={() => handleTabClick("noncashwallet")}
                            >
                              <Link
                                className={
                                  currentPage === "noncashwallet"
                                    ? "active"
                                    : ""
                                }
                                onClick={() => {
                                  setSlidebar(false);
                                  setShowDropdown2(false);
                                }}
                              >
                                <i>
                                  <img
                                    src="/images/profilew.png"
                                    alt="Logo"
                                    className="hover-image"
                                    style={{
                                      width: "auto",
                                      height: "16px",
                                      objectFit: "contain",
                                    }}
                                  />
                                </i>{" "}
                                &nbsp;
                                {t("userProfile.profileNav.nonCashWallet")}
                              </Link>
                            </li>
                            <li
                              className="user-item"
                              onClick={() => handleTabClick("usergameplay")}
                            >
                              <Link
                                className={
                                  currentPage === "usergameplay" ? "active" : ""
                                }
                                onClick={() => {
                                  setSlidebar(false);
                                  setShowDropdown2(false);
                                }}
                              >
                                <i>
                                  <img
                                    src="/images/profilew.png"
                                    alt="Logo"
                                    className="hover-image"
                                    style={{
                                      width: "auto",
                                      height: "16px",
                                      objectFit: "contain",
                                    }}
                                  />
                                </i>{" "}
                                &nbsp;{t("userProfile.profileNav.gameplay")}
                              </Link>
                            </li>
                          </ul>
                        )}
                      </li>
                    </ul>

                    <ul className="user-box">
                      <li className="nav-dropdown-item" ref={dropdownRef}>
                        <div
                          className={`nav-dropdown-toggle ${currentPage.startsWith("Withdraw-Requests") ? "active" : ""}`}
                          onClick={() => setShowDropdown1(!showDropdown1)}
                        >
                          <i>
                            <img
                              src="/images/withdraww.png"
                              alt="Logo"
                              className="nav-dropdown-icon desktop-margin"
                              style={{
                                width: "auto",
                                height: "16px",
                                objectFit: "contain",
                              }}
                              //  style={{ width: "auto", height: "16px", marginTop: "-40px" }}
                            />
                          </i>
                          &nbsp;
                          <span className="rg-text">
                            {t("userProfile.profileNav.responsible")}{" "}
                            <span className="line-break">
                              {t("userProfile.profileNav.gaming")}{" "}
                            </span>
                          </span>
                          <IoIosArrowDown />
                        </div>

                        {showDropdown1 && (
                          <ul className="nav-dropdown-menu">
                            <li
                              className="user-item"
                              onClick={() => handleTabClick("limits")}
                            >
                              <Link
                                className={
                                  currentPage === "limits" ? "active" : ""
                                }
                                onClick={() => {
                                  setSlidebar(false);
                                  setShowDropdown1(false);
                                }}
                              >
                                <i>
                                  <img
                                    src="/images/profilew.png"
                                    alt="Logo"
                                    className="hover-image"
                                    style={{
                                      width: "auto",
                                      height: "16px",
                                      objectFit: "contain",
                                    }}
                                  />
                                </i>{" "}
                                &nbsp;{t("userProfile.profileNav.limits")}
                              </Link>
                            </li>
                            <li
                              className="user-item"
                              onClick={() => handleTabClick("timeout")}
                            >
                              <Link
                                className={
                                  currentPage === "timeout" ? "active" : ""
                                }
                                onClick={() => {
                                  setSlidebar(false);
                                  setShowDropdown1(false);
                                }}
                              >
                                <i>
                                  <img
                                    src="/images/profilew.png"
                                    alt="Logo"
                                    className="hover-image"
                                    style={{
                                      width: "auto",
                                      height: "16px",
                                      objectFit: "contain",
                                    }}
                                  />
                                </i>{" "}
                                &nbsp;{t("userProfile.profileNav.timeOut")}
                              </Link>
                            </li>
                            <li
                              className="user-item"
                              onClick={() => handleTabClick("self-exclusion")}
                            >
                              <Link
                                className={
                                  currentPage === "self-exclusion"
                                    ? "active"
                                    : ""
                                }
                                onClick={() => {
                                  setSlidebar(false);
                                  setShowDropdown1(false);
                                }}
                              >
                                <i>
                                  <img
                                    src="/images/profilew.png"
                                    alt="Logo"
                                    className="hover-image"
                                    style={{
                                      width: "auto",
                                      height: "16px",
                                      objectFit: "contain",
                                    }}
                                  />
                                </i>{" "}
                                &nbsp;
                                {t("userProfile.profileNav.selfExclusion")}
                              </Link>
                            </li>
                          </ul>
                        )}
                      </li>
                      <li
                        className="user-item"
                        onClick={() => handleTabClick("verification")}
                      >
                        <Link
                          className={
                            currentPage === "verification" ? "active" : ""
                          }
                          onClick={() => setSlidebar(false)}
                        >
                          <i>
                            <img
                              src="/images/withdraww.png"
                              alt="Logo"
                              className="hover-image1"
                              style={{
                                width: "auto",
                                height: "16px",
                                objectFit: "contain",
                              }}
                            />
                          </i>{" "}
                          &nbsp;{t("userProfile.profileNav.verification")}
                        </Link>
                      </li>
                    </ul>

                    <ul className="user-box">
                      <li
                        className="user-item"
                        onClick={() => handleTabClick("withdraw-requests")}
                      >
                        <Link
                          className={
                            currentPage === "withdraw-requests" ? "active" : ""
                          }
                          onClick={() => setSlidebar(false)}
                        >
                          <i>
                            <img
                              src="/images/withdraww.png"
                              alt="Logo"
                              className="hover-image1"
                              style={{
                                width: "auto",
                                height: "16px",
                                objectFit: "contain",
                              }}
                            />
                          </i>{" "}
                          &nbsp; {t("userProfile.profileNav.withdraw")}
                        </Link>
                      </li>

                      <li
                        className="user-item"
                        onClick={() => handleTabClick("changePassword")}
                      >
                        <Link
                          className={
                            currentPage === "changePassword" ? "active" : ""
                          }
                          onClick={() => setSlidebar(false)}
                        >
                          <i>
                            <img
                              src="/images/withdraww.png"
                              alt="Logo"
                              className="hover-image1"
                              style={{
                                width: "auto",
                                height: "16px",
                                objectFit: "contain",
                              }}
                            />
                          </i>{" "}
                          &nbsp; {t("userProfile.profileNav.password")}
                        </Link>
                      </li>
                    </ul>
                    <ul className="user-box">
                      <li className="user-item">
                        <Link to="/">
                          <i>
                            <img
                              src="/images/supportw.png"
                              alt="Logo"
                              className="hover-image4"
                              style={{
                                width: "auto",
                                height: "16px",
                                objectFit: "contain",
                              }}
                            />
                          </i>{" "}
                          &nbsp; {t("userProfile.profileNav.signOut")}
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </Col>
              <Col className={`col-lg-6 `}>
                {currentPage === "cashwallet" && (
                  <Demo1 parentCallback={handleCallback} />
                )}
                {currentPage === "limits" && (
                  <Demo2 parentCallback={handleCallback} />
                )}
                {currentPage === "demo3" && (
                  <Demo3 parentCallback={handleCallback} />
                )}
                {currentPage === "self-exclusion" && (
                  <Demo4 parentCallback={handleCallback} />
                )}
                {currentPage === "changePassword" && (
                  <Demo5 parentCallback={handleCallback} />
                )}
                {currentPage === "withdraw-requests" && (
                  <Demo6 parentCallback={handleCallback} />
                )}
                {currentPage === "verification" && (
                  <Demo7 parentCallback={handleCallback} />
                )}
                {currentPage === "profile" && (
                  <Demo8 parentCallback={handleCallback} />
                )}
                {currentPage === "noncashwallet" && (
                  <Demo9 parentCallback={handleCallback} />
                )}
                {currentPage === "usergameplay" && (
                  <Demo10 parentCallback={handleCallback} />
                )}
                {currentPage === "timeout" && (
                  <Demo11 parentCallback={handleCallback} />
                )}
              </Col>
              <Col
                className={`col-lg-3 mt-5 ${slidebar === true ? "active" : "disactive"} d-none d-lg-block`}
              >
                <div
                  className={`dashboard-sidebar mt-5 ${
                    slidebar == true ? "active" : "disactive"
                  }`}
                >
                  <div className="third-div">
                    <ul className="info-box">
                      <li className="info">
                        <AiOutlineInfoCircle />
                        <span>{t("userProfile.accountInfo.title")}</span>
                      </li>
                      <li className="inner-info">
                        {t("userProfile.accountInfo.saveNote")}
                      </li>
                      <li>{t("userProfile.accountInfo.deactivateNote")}</li>
                    </ul>
                  </div>
                </div>
              </Col>
              {/* <Col

                className={`col-lg-3 mt-5 ${slidebar == true ? "active" : ""
                  }`}
              >

              </Col> */}
            </Row>
          </div>
        </section>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  const { user } = state.Auth;
  return user;
};
export default connect(mapStateToProps)(UserProfile);
